<template>
<v-app>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <!--div class="card" v-if="$gate.isAdmin()"-->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Kantor List</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>Nama Kantor</th>
                      <th>Cakupan Kabupaten</th>
                      <th>Saldo Akhir</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(row, rowIndex) in datas.data" :key="row.id">

                      <td>{{rowIndex+1}}</td>
                      <td>{{row.value}}</td>
                      <td>{{row.kabupatens.length > 0 ? row.kabupatens.map(a => a.value).join(", ") : ''}}</td>
                      <td>
                        {{row.saldo_akhir ? row.saldo_akhir.saldo : '' | toCurrency}}
                        <a href="#" @click="addDuit(row)" v-show="!row.saldo_akhir">
                            <i class="fa fa-plus-circle text-blue"></i>
                        </a>
                      </td>
                      <td>
                        <a href="#" @click="editModal(row)" class="mr-1">
                            <i class="fa fa-edit text-blue"></i>
                        </a>
                        /
                        <a href="#" @click="deleteData(row.id)" class="ml-1">
                            <i class="fa fa-trash text-red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="datas" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New Kantor</h5>
                    <h5 class="modal-title" v-show="editmode">Update Kantor Info</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateData() : createData()">
                    
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>Nama Kantor</label>
                                    <input v-model="form.value" type="text" name="value"
                                        class="form-control" :class="{ 'is-invalid': form.errors.has('value') }" >
                                    <has-error :form="form" field="value"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Lokasi Kabupaten Kantor</label>
                                    <v-select
                                        v-model="form.kabupatens"
                                        :items="kabupaten_list"
                                        item-text="value"
                                        item-value="id"
                                        label="Pilih Kabupaten"
                                        multiple
                                        hint="Pilih Kabupaten Yang Diawasi Kantor ini"
                                        persistent-hint
                                    ></v-select>
                                    <has-error :form="form" field="kabupatens"></has-error>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                            </div>
                        
                  </form>
                </div>
            </div>
                    
        </div>

        <div class="modal fade" id="modalDuit" tabindex="-1" role="dialog" aria-labelledby="modalDuit" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Setting Saldo Awal Kantor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="setDana()">
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Nama Kantor</label>
                                <input v-model="duit.value" type="text" name="value"
                                    class="form-control" :class="{ 'is-invalid': duit.errors.has('value') }" :disabled="true">
                                <has-error :duit="duit" field="value"></has-error>
                            </div>
                            <div class="form-group">
                                <label>Saldo Kantor (Rp.) <small>(Hanya Angka)</small></label>
                                <input v-model="duit.saldo" type="number" name="saldo" @keydown="preventArrow($event)" min="0"
                                    class="form-control" :class="{ 'is-invalid': duit.errors.has('saldo') }" >
                                <has-error :duit="duit" field="saldo"></has-error>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Submit</button>
                        </div>
                  </form>
                </div>
            </div>
                    
        </div>
    </div>
  </section>
  </v-app>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                datas : {},
                form: new Form({
                    id : '',
                    value: '',
                    kabupatens: []
                }),
                duit: new Form({
                    id : '',
                    value: '',
                    saldo: '0'
                }),
                kabupaten_list : [],
            }
        },
        methods: {
            preventArrow(e) {
                if (e.which === 38 || e.which === 40) {
                    e.preventDefault();
                }
            // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
            },
            loadKabupaten(){
                axios.get("api/kabupaten/list?q=" + escape(1)).then(({ data }) => (this.kabupaten_list = data.data));
            },
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('api/kantor?page=' + page).then(({ data }) => (this.datas = data.data));

                  this.$Progress.finish();
            },
            setDana(){
                this.$Progress.start();
                Swal.fire({
                title: 'Are you sure?',
                text: "Apakah Anda Yakin Untuk Mengupdate Saldo Kantor ini?",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes!'
                }).then((result) => {
                if (result.value) {
                    let editFormData = new FormData();
                    let dataUpdate = {};
                    dataUpdate['id'] = this.duit.id;
                    dataUpdate['saldo'] = this.duit.saldo;
                    dataUpdate['value'] = this.duit.value;
                    
                    editFormData.append('datanya', JSON.stringify(dataUpdate));
                    axios.post('api/kantor/setDana', editFormData).then((data) => {
                    if(data.data.success){

                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.$Progress.finish();
                        this.loadDatas();
                        $('#modalDuit').modal('hide');
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: "Error!. Try again later."
                        });

                        this.$Progress.fail();
                    }
                    })
                    .catch(e => {
                        Toast.fire({
                            icon: 'error',
                            title: "Error!."
                        });
                        //console.log( e.response.data.errors);

                        this.$Progress.fail();
                    });
                }
                })
            },
            updateData(){
                this.$Progress.start();
                // console.log('Editing data');
                this.form.put('api/kantor/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadDatas();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(user){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(user);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },
            addDuit(row){
                this.duit.reset();
                $('#modalDuit').modal('show');
                this.duit.fill(row);
            },
            deleteData(id){
                if(id != 1){
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {

                            // Send request to the server
                            if (result.value) {
                                    this.form.delete('api/kantor/'+id).then(()=>{
                                            Swal.fire(
                                            'Deleted!',
                                            'Your file has been deleted.',
                                            'success'
                                            );
                                        // Fire.$emit('AfterCreate');
                                        this.loadDatas();
                                    }).catch((data)=> {
                                    Swal.fire("Failed!", data.message, "warning");
                                });
                            }
                        });
                }else{
                    Swal.fire("Failed!", "Kantor Tidak Dapat Dihapus", "warning");
                }
            },
          loadDatas(){
            if(this.$gate.isAdmin()){
              axios.get("api/kantor").then(({ data }) => (this.datas = data.data));
            }
          },
          createData(){

              this.form.post('api/kantor')
              .then((response)=>{
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: response.data.message
                  });

                  this.$Progress.finish();
                  this.loadDatas();

              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          }

        },
        mounted() {
            console.log('Kantor Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadDatas();
            this.loadKabupaten();
            this.$Progress.finish();
        }
    }
</script>
<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>